import React from 'react';
import './KeyboardShortcuts.css';

interface KeyboardShortcutsProps {
  show?: boolean;
}

const KeyboardShortcuts: React.FC<KeyboardShortcutsProps> = ({ show = true }) => {
  if (!show) return null;

  return (
    <div className="keyboard-shortcuts">
      <div className="shortcut-item">
        <kbd>←</kbd>
        <span>Previous</span>
      </div>
      <div className="shortcut-item">
        <kbd>→</kbd>
        <span>Next</span>
      </div>
      <div className="shortcut-item">
        <kbd>Space</kbd>
        <span>Play/Pause</span>
      </div>
      <div className="shortcut-item">
        <kbd>↑</kbd>
        <span>Speed Up</span>
      </div>
      <div className="shortcut-item">
        <kbd>↓</kbd>
        <span>Speed Down</span>
      </div>
    </div>
  );
};

export default KeyboardShortcuts;